import { useI18n } from "@/i18n";
import { Sun, Moon } from "lucide-react";

/**
 * Sun/Moon toggle that flips `data-theme` on <html>. Persists in localStorage
 * via the I18nProvider. Compact icon-only design — fits in the header next to
 * the language switcher.
 */
export default function ThemeToggle({ className = "" }) {
  const { theme, setTheme } = useI18n();
  const isLight = theme === "light";
  return (
    <button
      type="button"
      onClick={() => setTheme(isLight ? "dark" : "light")}
      className={`inline-flex items-center justify-center w-8 h-8 rounded text-faded hover:text-gold transition ${className}`}
      data-testid="theme-toggle"
      aria-label={isLight ? "Cambiar a tema oscuro" : "Cambiar a tema claro"}
      title={isLight ? "Modo oscuro" : "Modo claro"}
    >
      {isLight ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
    </button>
  );
}
